import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["dimensions", "customCSSStyles", "Template"],
  _excluded2 = ["dimensions", "containerCSSStyles", "customCSSStyles", "Template"];
import { useTheme } from 'foundations-theming/utils';
import { MERCURY_LAYER } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultTemplate = _ref => {
  let {
      dimensions,
      customCSSStyles,
      Template
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  return /*#__PURE__*/_jsx(Template, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMin slice",
    viewBox: `0 0 ${dimensions.width} ${dimensions.height}`,
    $cssStyles: Object.assign({
      overflow: 'visible !important',
      pointerEvents: 'none',
      position: 'relative',
      verticalAlign: 'bottom' /* for IE11 */,
      width: '100%',
      zIndex: MERCURY_LAYER,
      height: 'auto',
      paddingBottom: theme.space['0']
    }, customCSSStyles)
  }, rest));
};
export const AbstractDeviceTemplate = _ref2 => {
  let {
      dimensions,
      containerCSSStyles,
      customCSSStyles,
      Template
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(DefaultTemplate, Object.assign({}, rest, {
    dimensions: dimensions,
    containerCSSStyles: containerCSSStyles,
    customCSSStyles: customCSSStyles,
    Template: Template
  }));
};